import { routes } from 'lib/routes';

export default function redirectWithFlash(path, flashes) {
  window.location = routes.safely_redirect_with_flash_path({
    messages: flashes,
    return_to: path,
  });
}
